/** Full battle UUID for tooltips / copy; compact label for narrow headers. */
export function battleUuidLabel(uuid: string, compact = false): string {
  const clean = uuid.trim();
  if (!clean) return '—';
  if (!compact) return clean;
  if (clean.length <= 12) return clean;
  return `${clean.slice(0, 8)}…${clean.slice(-4)}`;
}
